import type { OrderChannelEvent, OrderCancelReason } from "@estelle/domain";

/** Shopify's `OrderCancelReason` values (2026-07), worded as its admin words them. */
export const CANCEL_REASONS: { value: OrderCancelReason; label: string }[] = [
  { value: "CUSTOMER", label: "Customer changed or cancelled order" },
  { value: "DECLINED", label: "Payment declined" },
  { value: "FRAUD", label: "Fraudulent order" },
  { value: "INVENTORY", label: "Items unavailable" },
  { value: "STAFF", label: "Staff error" },
  { value: "OTHER", label: "Other" },
];

/**
 * The reason a cancellation was filed under, not who cancelled. Shopify's
 * dialog defaults to CUSTOMER, so staff cancelling an order often leave it
 * there (#568); the header says "Reason" so it is not read as the actor.
 */
export function cancelReasonLabel(reason: string): string {
  return (
    CANCEL_REASONS.find((r) => r.value === reason)?.label ??
    reason.toLowerCase()
  );
}

/**
 * Who cancelled, from Shopify's own timeline line ("Coderlectual cancelled
 * this order."). Null when Shopify has not sent that event or worded it
 * differently, so the header never guesses an actor.
 */
export function cancelledBy(
  events: OrderChannelEvent[],
  plain: (html: string | null) => string,
): string | null {
  const event = events.find(
    (e) => e.kind === "event" && e.action === "cancelled",
  );
  const match = /^(.+?) cancelled this order/i.exec(
    plain(event?.message ?? null),
  );
  return match?.[1] ? `by ${match[1]}` : null;
}
